<template>
    <div id="app">
        <div class="header">
            <img src="./assets/hangyuan_logo.png" alt="">
        </div>
        <div class="page">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>

    </div>
</template>

<script>

    export default {
        name: 'App',
        components: {},
        created() {
            // this.$request('get', 'getCode', {}).then((res) => {
            //     console.log('res', res);
            //     localStorage.setItem('isAsk', false);
            //     if (res.data == 0) {
            //         this.$message.success('发送成功');
            //     } else {
            //         this.$message.error(res.message);
            //     }
            // })
        },
    }
</script>

<style>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        /*margin-top: 60px;*/
    }

    .header {
        width: 100%;
        /*height: 50px;*/
        background: #3365e1;
        box-sizing: border-box;
        padding: 10px 145px;
        text-align: left;
        vertical-align: middle;
    }

    .header img {
        width: 240px;
        height: 40px;
    }

    .page {
        margin-top: 60px;
    }

    @media only screen and (max-width: 500px) {
        .header {
            padding: 10px 10px;
        }

    }

    @media only screen and (max-width: 768px) {
        .header {
            padding: 10px 10px;
        }

        .page {
            margin-top: 30px;
        }

    }
</style>
